// extracted by mini-css-extract-plugin
export default {"page":"ProjectListPage_page__Cjh+t","greeting":"ProjectListPage_greeting__0gl36"};